export default "__VITE_ASSET__BQuhIuT5__"